import $ from 'jquery';
export default function (num) {
  return $(window).width() * num / 750;
}